import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
export function Philosophy() {
  return <section className="py-20 md:py-24 px-6 md:px-12 max-w-6xl mx-auto" data-id="element-134">
      <div className="grid md:grid-cols-12 gap-10 md:gap-14 items-center" data-id="element-135">
        {/* Image column */}
        <div className="md:col-span-6 order-2 md:order-2" data-id="element-136">
          <div className="rounded-2xl overflow-hidden bg-white shadow-sm max-w-md mx-auto md:max-w-none" data-id="element-137">
            <img src="https://cdn.magicpatterns.com/uploads/4KfhmgkQqz64Yc7q27ChQR/ChatGPT_Image_May_27,_2026,_01_20_20_PM.png" alt="Illustration of a mentor teaching a young person to fish by a lake, with the proverb: Give a man a fish, and you feed him for a day; teach a man to fish, and you feed him for a lifetime." className="w-full h-auto" data-id="element-138" />
          </div>
        </div>

        {/* Text column */}
        <div className="md:col-span-6 order-1 md:order-1" data-id="element-139">
          <p className="text-xs uppercase tracking-widest text-accent mb-4 font-medium" data-id="element-140">
            The Philosophy
          </p>
          <h2 className="text-4xl md:text-5xl font-serif leading-[1.1] mb-6" data-id="element-141">
            Built to last beyond Year One<span className="text-accent" data-id="element-142">.</span>
          </h2>

          <p className="text-lg text-ink/80 mb-6 leading-relaxed font-light" data-id="element-143">
            Year One is designed as a real-world finishing school — not a
            shortcut. The goal is to set you up for life, not to make you
            dependent on support.
          </p>

          <p className="font-serif text-xl md:text-2xl text-teal leading-snug mb-8" data-id="element-144">
            I'm a big believer in teaching people{' '}
            <span className="italic" data-id="element-145">how to fish</span> — how to think, adapt,
            build relationships, and move forward on their own with confidence.
          </p>

          <Link to="/about#philosophy" className="inline-flex items-center gap-1.5 text-teal font-medium hover:text-teal/70 transition-colors group" data-id="element-146">
            <span className="border-b border-teal/40 group-hover:border-teal/70" data-id="element-147">
              Read more about my approach
            </span>
            <ArrowRightIcon className="w-4 h-4 transition-transform group-hover:translate-x-0.5" data-id="element-148" />
          </Link>
        </div>
      </div>
    </section>;
}